import React from 'react';

import * as api from '@test_prep/app/ai_tutor/api';
import { Activity, Interaction, InteractionPart } from '@test_prep/app/ai_tutor/types';

import ActivityOffer from './activity_offer';
import Chat from './chat';
import ChatHint from './chat_hint';
import ContentOffer from './content_offer';
import DomainOffer from './domain_offer';
import PromptActivity from './prompt_activity';

interface Props {
  addOrUpdateUserInteractions: (interactions: Interaction[]) => void;
  interaction: Interaction;
  interactionPart: InteractionPart;
  setCurrentActivity: (activity: Activity) => void;
  submitUserInput: (text: string) => void;
  updateInteractionPart: (interactionPart: InteractionPart) => void;
}

export default (props: Props) => {
  if (props.interactionPart.type === 'prompt_activity') {
    const activity = { interaction: props.interaction, interactionPart: props.interactionPart };
    return (
      <PromptActivity
        activity={activity}
        onClick={() => props.setCurrentActivity(activity)}
      />
    );
  } else if (props.interactionPart.type === 'activity_offer') {
    return (
      <ActivityOffer
        addOrUpdateUserInteractions={props.addOrUpdateUserInteractions}
        interaction={props.interaction}
        interactionPart={props.interactionPart}
      />
    );
  } else if (props.interactionPart.type === 'chat_hint') {
    return (
      <ChatHint
        interactionPart={props.interactionPart}
        submitUserInput={props.submitUserInput}
      />
    );
  } else if (props.interactionPart.type === 'chat') {
    return <Chat interactionPart={props.interactionPart} />;
  } else if (props.interactionPart.type === 'content_offer') {
    return (
      <ContentOffer interactionPart={props.interactionPart} />
    );
  } else if (props.interactionPart.type === 'domain_offer') {
    return (
      <DomainOffer
        interactionPart={props.interactionPart}
        updateInteractionPart={props.updateInteractionPart}
      />
    );
  }  else {
    return null;
  }
};
